import React from 'react';
import {Item,MyLink} from './Navlink'
import { Link, animateScroll as scroll } from "react-scroll";
import '../../Sections/Appbar/scss/appbar.css'


export default function NavLink(props){

    const {href,linkTo, ...otherProps} = props;

return(
    
    <Item> 

    {/* <MyLink active = {props.active} href = {props.href} > */}
    <Link
    className = "linkclass"
    activeClass="active"
    to= {linkTo}
    spy={true}
    smooth={true}
    duration={500}
    offset = {props.children === "Contact" ? 100 : 0}
    >
     {props.children} 
    </Link>
    {/* </MyLink> */}
    </Item>
   

    
)

}